const testimonials = [
  {
    name: "María G.",
    text: "Scout Conecta ha revolucionado cómo organizamos nuestras actividades scout. La interfaz es intuitiva y las herramientas de gestión son increíbles.",
    avatar: "👩‍💻"
  },
  {
    name: "Carlos M.",
    text: "Ascensos App Vortex es exactamente lo que necesitaba para mi preparación naval. Las herramientas de IA son impresionantes y los audios son de gran calidad.",
    avatar: "👨‍💼"
  },
  {
    name: "Ana L.",
    text: "Vortex Texto-Audio me ha ayudado muchísimo con mis estudios. Convertir textos largos en audios naturales es un cambio total en mi forma de aprender.",
    avatar: "👩‍💼"
  },
  {
    name: "Roberto S.",
    text: "Flashcard Vortex con IA es genial. Genera tarjetas automáticamente y el sistema de repetición espaciada realmente funciona. ¡Altamente recomendado!",
    avatar: "👨‍💻"
  },
  {
    name: "Laura P.",
    text: "Cuentos que enseñan es perfecto para mis hijos. Los temas escolares se convierten en aventuras divertidas generadas por IA. ¡Mis niños aman estudiar ahora!",
    avatar: "👩‍🏫"
  },
  {
    name: "Miguel R.",
    text: "Vortex Audio Texto IA transcribe mis grabaciones de reuniones en segundos. La precisión es sorprendente y me ahorra horas de trabajo.",
    avatar: "👨‍💼"
  }
]

export default function Testimonials() {
  return (
    <section id="testimonials" className="section">
      <div className="container">
        <div className="text-center mb-2xl">
          <h2>Lo que dicen nuestros usuarios</h2>
          <p style={{ maxWidth: '800px', margin: '0 auto' }}>
            Historias reales de usuarios que han transformado su experiencia de aprendizaje con nuestras aplicaciones
          </p>
        </div>

        <div className="grid grid-3">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              style={{
                background: 'var(--bg-tertiary)',
                borderRadius: 'var(--radius-lg)',
                padding: 'var(--spacing-xl)',
                border: '1px solid var(--border)',
                transition: 'all var(--transition-normal)',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-4px)'
                e.target.style.boxShadow = 'var(--shadow-lg)'
                e.target.style.borderColor = 'var(--accent)'
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)'
                e.target.style.boxShadow = 'none'
                e.target.style.borderColor = 'var(--border)'
              }}
            >
              <div style={{
                fontSize: '2rem',
                marginBottom: 'var(--spacing-md)',
                textAlign: 'center'
              }}>
                {testimonial.avatar}
              </div>

              <blockquote style={{
                fontStyle: 'italic',
                marginBottom: 'var(--spacing-lg)',
                color: 'var(--text-secondary)',
                fontSize: '1rem',
                lineHeight: '1.6'
              }}>
                "{testimonial.text}"
              </blockquote>

              <div style={{ textAlign: 'center' }}>
                <div style={{
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  marginBottom: 'var(--spacing-xs)'
                }}>
                  {testimonial.name}
                </div>
                <div style={{
                  color: 'var(--text-muted)',
                  fontSize: '0.875rem'
                }}>

                </div>
              </div>
            </div>
          ))}
        </div>

        <div style={{
          marginTop: 'var(--spacing-3xl)',
          textAlign: 'center'
        }}>
          <h3 style={{ marginBottom: 'var(--spacing-lg)' }}>
            Únete a Vortex y veras un camino con mas posibilidades de exito.
          </h3>
          <p style={{ marginBottom: 'var(--spacing-xl)' }}>
            Comienza tu viaje hacia el éxito con nuestras aplicaciones hoy mismo.
          </p>
          <a href="#availability" className="btn btn-primary">
            Explorar aplicaciones
          </a>
        </div>
      </div>
    </section>
  )
} 